import React, { useState, useEffect } from 'react';
import { learningPathsAPI } from '../../services/api';
import { useTranslation } from 'react-i18next';
import CourseCard from '../CourseCard';
import Card from '../UIKit/Card';
import { Box, Typography } from '@mui/material';

const NextCoursesFromPath = () => {
  const [nextCourses, setNextCourses] = useState([]);
  const [activePath, setActivePath] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation(['learningPaths', 'common']);

  useEffect(() => {
    loadActivePathAndNextCourses();
  }, []);

  const loadActivePathAndNextCourses = async () => {
    try {
      setLoading(true);
      setError(null);

      // Получаем активную дорожку
      const activeResponse = await learningPathsAPI.getActive();
      const activePathData = activeResponse.data.activeLearningPath;

      if (!activePathData) {
        setLoading(false);
        return;
      }

      setActivePath(activePathData);

      // Получаем следующие курсы
      const nextCoursesResponse = await learningPathsAPI.getNextCourses();
      setNextCourses(nextCoursesResponse.data.nextCourses || []);

    } catch (err) {
      console.error('Ошибка при загрузке активной дорожки:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading || error || !activePath || nextCourses.length === 0) {
    return null;
  }

  return (
    <Card sx={{ mb: 2 }}>
      <Typography variant="h5" component="h3" sx={{ mb: 2, fontWeight: 700 }}>
        {t('learningPaths:nextCourses')}
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {nextCourses.map((courseItem) => (
          <CourseCard
            course={courseItem.course}
            key={courseItem.course._id}
            isNext={courseItem.isNext}
            sx="w-full"
          />
        ))}
      </Box>
    </Card>
  );
};

export default NextCoursesFromPath;

